import { Image } from "antd";
import { useResilientImageSrc } from "./useResilientImageSrc";

function ResilientAntImage({
    src,
    alt = "",
    className,
    loading,
    placeholder,
    placeholderClassName = "detail-image-placeholder",
    ...rest
}) {
    const { src: resolvedSrc, handleError, failed } = useResilientImageSrc(src);

    if (failed) {
        return (
            <div
                className={placeholderClassName}
                role="img"
                aria-label={alt}
            />
        );
    }

    return (
        <Image
            key={resolvedSrc}
            src={resolvedSrc}
            alt={alt}
            className={className}
            loading={loading}
            placeholder={placeholder}
            onError={handleError}
            {...rest}
        />
    );
}

export default ResilientAntImage;
